import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { CakeIcon, HeartIcon, BriefcaseIcon, BabyIcon, UsersIcon } from 'lucide-react';
export function SweetTables() {
  const events = [{
    icon: CakeIcon,
    title: 'Cumpleaños',
    image: 'https://cdn.magicpatterns.com/uploads/23VaQtR1FtjqZFBKZSVNt6/Hitube_B4rNHKevfF_2026_05_13_00_56_40.jpg'
  }, {
    icon: HeartIcon,
    title: 'Bodas',
    video: 'https://cdn.magicpatterns.com/uploads/cuCXzkMDsyQZFdKewyLsSc/Hitube_z2Pz8aBm4M_2026_05_13_01_02_11.mp4'
  }, {
    icon: BriefcaseIcon,
    title: 'Regalos empresariales',
    image: 'https://cdn.magicpatterns.com/uploads/piKJ9T96eGg6xFyEaST5TB/Hitube_VBxmIdahbH_2026_05_13_01_04_35.jpg'
  }, {
    icon: UsersIcon,
    title: 'Eventos Sociales',
    image: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=600&q=80'
  }];
  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hola! Quiero consultar por mesas dulces para un evento.');
    window.open(`https://wa.me/5492665013601?text=${message}`, '_blank');
  };
  return <section id="mesas-dulces" className="py-20 bg-secondary-cream-dark" data-id="element-158">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-160">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-secondary-brown mb-4" data-id="element-161">
            Mesas dulces y regalos especiales
          </h2>
          <p className="text-xl text-secondary-brown-light max-w-3xl mx-auto italic mb-8" data-id="element-162">
            "Creamos mesas dulces y regalos especiales únicos que convierten
            cada evento en un momento inolvidable."
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-163">
          {events.map((event, index) => <motion.div key={event.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          scale: 1.05
        }} className="relative h-80 rounded-2xl overflow-hidden shadow-xl group cursor-pointer" data-id="element-164">
              {event.video ? <video src={event.video} autoPlay loop muted playsInline className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-165" /> : <img src={event.image} alt={event.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-166" />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-167" />
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white" data-id="element-168">
                <event.icon className="mb-3" size={32} data-id="element-169" />
                <h3 className="text-2xl font-serif font-semibold" data-id="element-170">
                  {event.title}
                </h3>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-171">
          <button onClick={handleWhatsApp} className="bg-primary-yellow text-secondary-brown px-10 py-4 rounded-full font-semibold text-lg hover:bg-primary-gold transition-all transform hover:scale-105 shadow-lg" data-id="element-172">
            Consultar por Eventos
          </button>
        </motion.div>
      </div>
    </section>;
}